import { useTranslation } from "@/i18n/use-translation";

export function AppErrorFallback() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="max-w-md space-y-4 text-center">
        <h1 className="text-2xl font-semibold">{t("errors.appTitle")}</h1>
        <p className="text-muted-foreground">{t("errors.appDescription")}</p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
        >
          {t("errors.reload")}
        </button>
      </div>
    </div>
  );
}
